import Vue from "vue";
import Vuex from "vuex";
import VuexPersist from "vuex-persist";
import LocalForage from "localforage";
import app from "./modules/app";
import page from "./modules/page";
import login from "./modules/login";
import actions from "./modules/actions";
import notifications from "./modules/notifications";
import errors from "./modules/errors";
import settings from "./modules/settings";
import group from "./modules/group";
import poi from "./modules/poi";
import network from "./modules/network";

Vue.use(Vuex);

const localForage = LocalForage.createInstance({
  name: "followup"
});

const persistPage = new VuexPersist({
  key: "followup-page",
  storage: window.localStorage,
  modules: ["page"]
});

const persistActions = new VuexPersist({
  key: "followup-actions",
  storage: localForage,
  modules: ["actions"]
});

const debug = process.env.NODE_ENV !== "production";

export default new Vuex.Store({
  modules: {
    app,
    page,
    login,
    actions,
    notifications,
    errors,
    settings,
    group,
    poi,
    network
  },
  strict: debug,
  plugins: [persistPage.plugin, persistActions.plugin]
});
